<script setup>

import Stock from "@/components/warehouse/Stock";
import SlideInDrawer from "@/components/common/navigation/SlideInDrawer";
import Table from "@/components/common/other/Table";
import {inject, ref} from 'vue'

const stockSearch = inject('stockSearch');

const updateGridRender = ref();

</script>

<template>
  <SlideInDrawer
      :height="300"
      title="Line Details"
      v-model:open-drawer="stockSearch.openDetailsDrawer">
    <template #icon><i class="fa-solid fa-warehouse-full" style="color: #eab410;"></i></template>
    <div style="margin-top: 20px; width: 1790px; padding-left: 5px;">
      <Table
          :key="updateGridRender"
          :allowGridMenu="false"
          height="160"
          :selectable="false"
          :row-selection="false"
          v-model:currentPage="stockSearch.lineGridCurrentPage"
          v-model:currentPaginationRange="stockSearch.lineGridPageRange"
          :dataSource="stockSearch.lineData"
          :columns="stockSearch.tempLineCols">
      </Table>
    </div>
  </SlideInDrawer>
  <Stock></Stock>
</template>

<style scoped>

</style>
